<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{ $t('form.edit', { item: $t('targets.target') }) }}</strong>
        </b-card-header>
        <b-card-body>
            <div v-if="permissions.modules.has_goal">
                <Loader :loader="loader" />
                <Form
                    v-show="!loader"
                    @onSubmit="onSubmit"
                    :target="target"
                    :isEdit="true"
                    :can-edit="canEdit"
                    :is-referenced-goal="isReferencedGoal"
                    :current-event-permissions="permissions.current_event_permissions.goals"
                    :moduleForm="'target'"
                    :profileUserId="profileUserId"
                />
            </div>
            <div v-else>
                <b-alert show variant="warning" class="mt-3">
                    <i class="fa fa-warning"></i>
                    {{
                        $t('notification.permissions.editDenied', {
                            item: $t('targets.target'),
                        })
                    }}
                </b-alert>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import Form from '@/views/target/components/form'
import mapperFormToApi from './mappers/mapperFormToApi'
import mapperApiToForm from './mappers/mapperApiToForm'
import notification, { success, danger } from '@/lib/notification'
import { getParam as getUrlParam } from '@/lib/url'
import { getUserPermissions } from '@/services/user-permissions'
import { userPermissionsMixin } from '@/mixins'
import Loader from '@/views/components/loader'
import { getUserData } from '@/services/user-data'

notification.init()

export default {
    name: 'New',
    mixins: [userPermissionsMixin],
    components: {
        Form,
        Loader,
    },
    data() {
        return {
            id: getUrlParam('id', this),
            target: null,
            loader: true,
            permissions: {},
            targetLevel: null,
            userRelations: [],
            currentUserId: null,
        }
    },
    created() {
        this.permissions = getUserPermissions()
        this.currentUserId = getUserData().id
    },
    mounted() {
        if (this.permissions.modules.has_goal) {
            this.target = api
                .get(`/goals/${this.id}`)
                .then((resp) => {
                    const {
                        data: { data },
                    } = resp
                    this.targetLevel = data.level
                    this.userRelations = data.user_relations
                    return mapperApiToForm(data)
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    this.loader = false
                })
        } else {
            Swal({
                type: 'warning',
                title: i18n.t('notification.permissions.editDenied', {
                    item: i18n.t('targets.target'),
                }),
            })
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.put(`/goals/${this.id}`, mapperFormToApi(form))
                .then(() => {
                    onReset()
                    this.notificationRangeEditedSuccessfully()
                    this.goBack()
                })
                .catch((error) => {
                    console.log(error)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationRangeEditedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: i18n.t('targets.target'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
    computed: {
        profileUserId() {
            return this.$store.state.profile.user.id ? this.$store.state.profile.user.id : null
        },
        canEdit() {
            return this.permissions && this.targetLevel ? this.permissionsGoal : true
        },
        permissionsGoal() {
            if (this.userHasRolePermission) {
                return getUserPermissions().current_event_permissions.goals
            }
            return this.$store.state.filters.currentEventPermissions.goals[this.targetLevel].edit
        },
        userHasRolePermission() {
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_target_master']
            const currentUser = this.$store.state.currentUser.user
            const rolesPermission = this.userHasPermission(currentUser, availableRoles, [])
            return rolesPermission
        },
        isReferencedGoal() {
            if (this.userRelations) {
                return this.userRelations.some((relation) => {
                    return relation.id == this.profileUserId
                })
            }
            return false
        },
    },
}
</script>
